import { lazy } from 'react';
import MainLayout from '../containers/MainLayout/MainLayout';
import { RouteObject } from 'react-router-dom';
import Loadable from 'components/Loadable/Loadable';
import { SUBPAGE_PLATFORMS } from 'config/platforms';

// project imports
const HomePage = Loadable(lazy(() => import('containers/HomePage/HomePage')));
const Product = Loadable(lazy(() => import('containers/Product/Product')));
const ProductPage = Loadable(lazy(() => import('containers/ProductICG/ProductPage')));
const Page404 = Loadable(lazy(() => import('components/Error/Page404')));


export const Path = {
  HomePage: '/',
  Product: '/products',
}

// ==============================|| MAIN ROUTING ||============================== //
const MainRoutes: RouteObject = {
  path: '',
  element: <MainLayout />,
  children: [
    {
      path: Path.HomePage,
      element: <HomePage />
    },
    {
      path: Path.Product,
      element: <Product />
    },
    // 9 個平台子頁由 registry 衍生：原 ProductICG/Product*Gaming.tsx 已合併為單一 ProductPage。
    // Pinnacle 不在 SUBPAGE_PLATFORMS（hasSubPage=false），不產生 route。
    ...SUBPAGE_PLATFORMS.map((p) => ({
      path: p.path as string,
      element: <ProductPage config={p} />
    })),
    {
      path: '*',
      element: <Page404 />
    },
  ]
};

export default MainRoutes;
